import { render, staticRenderFns } from "./social-post-select-widget.vue?vue&type=template&id=a2876838&"
import script from "./social-post-select-widget.vue?vue&type=script&lang=js&"
export * from "./social-post-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./social-post-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports